import './VideoSection.css';

function VideoSection() {
  return (
    <section className="video-section">

      <div className="video-card">

        <video
          className="video-bg"
          autoPlay
          muted
          loop
          playsInline
        >
          <source
            src="/videos/4934366_Person_People_1920x1080.mp4"
            type="video/mp4"
          />
        </video>

        <div className="video-overlay">

          <h2>TRAIN HARD. LOOK STRONG.</h2>

          <p>Premium Gym Wear For Every Workout</p>

        </div>

      </div>

    </section>
  );
}

export default VideoSection;